"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  listItem: {
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    [_theme.default.breakpoints.down('xs')]: {
      fontSize: _theme.default.typography.pxToRem(15),
      paddingRight: 16,
      marginTop: 6,
      marginBottom: 6
    }
  }
});
var _default = exports.default = useStyles;